import { Fragment } from 'react';
import { NextPage } from 'next';

import { field, useForm, useSubmit, validate } from '@reckon-web/forms';
import { Flex } from '@reckon-web/flex';
import { Text } from '@reckon-web/text';
import { Button } from '@reckon-web/button';
import { Box } from '@reckon-web/box';
import { Notice } from '@reckon-web/notice';

import { TextField } from '../generic/TextField';

export const ResetPwdForm: NextPage<{
  onsubmit?: any;
  errorMessage?: string;
  setErrorMessage?: any;
  // children: ReactNode;
}> = ({
  onsubmit,
  errorMessage,
  setErrorMessage,
  // children,
}) => {
  let resetPasswordForm = field.object({
    password: field.text({
      validate: validate((value) => {
        if (!value.length) return validate.error('Enter your password');
        return value;
      }),
    }),
  });

  let form = useForm(resetPasswordForm);
  const submit = useSubmit(form, async (value) => {
    if (!value.password) return;
    onsubmit(value);
  });
  return (
    <Fragment>
      <form
        id="resetpassword-form"
        onChange={() => setErrorMessage('')}
        onSubmit={submit}
      >
        {errorMessage ? (
          <Box paddingBottom="xlarge">
            <Notice tone="critical">
              {errorMessage ? <Text>{errorMessage}</Text> : ''}
            </Notice>
          </Box>
        ) : null}

        <Flex
          direction="column"
          gap="medium"
          alignItems="center"
          padding="xlarge"
        >
          <Box
            paddingX="large"
            paddingY="medium"
            borderRadius="small"
            width={400}
          >
            <TextField
              type="password"
              label="Password"
              placeholder="Enter password"
              {...form.fields.password.props}
            />

            <Box marginTop="medium">
              <Button
                id="login"
                disabled={form.validity !== 'valid'}
                type="submit"
                size="medium"
                block
                label="Change Password"
              />
            </Box>
          </Box>
        </Flex>
      </form>
    </Fragment>
  );
};
